import { Bell } from "lucide-react";
import { LeadEditor } from "./LeadEditor";
import { STATUSES, fmtDate, StatusBadge } from "./leadUtils";

export { STATUSES, fmtDate, StatusBadge };

const followUpTone = (lead) => {
  if (lead.follow_up_sent) return "text-ink/40";
  if (new Date(lead.follow_up_at) < new Date()) return "text-destructive";
  return "text-ink/75";
};

export const FollowUpBadge = ({ lead }) => {
  if (!lead.follow_up_at) return <span className="text-ink/30">—</span>;
  return (
    <span data-testid={`follow-up-badge-${lead.id}`} className={`inline-flex items-center gap-1.5 font-sans-ui text-[11px] whitespace-nowrap ${followUpTone(lead)}`}>
      <Bell size={11} /> {fmtDate(lead.follow_up_at)}{lead.follow_up_sent ? " · inviato" : ""}
    </span>
  );
};

const fields = (l) => ({
  Nome: l.full_name, Email: l.email, WhatsApp: l.whatsapp, Paese: l.country, Attività: l.business_type,
  Piattaforma: l.selling_platform, "Ordini/mese": l.monthly_orders, Interessi: (l.interests || []).join(", "),
  Messaggio: l.message, "UTM Source": l.utm_source, "UTM Medium": l.utm_medium, "UTM Campaign": l.utm_campaign,
  "UTM Content": l.utm_content, "UTM Term": l.utm_term, Referrer: l.referrer, "Landing URL": l.landing_url,
  Device: l.device, "Event ID": l.event_id, "CAPI": l.capi_status ? `${l.capi_status}${l.capi_error ? ` — ${l.capi_error}` : ""}` : "—",
  "Email conferma": l.confirmation_sent ? "inviata al lead" : "—",
  Data: l.created_at,
});

export const LeadDetail = ({ lead, token, onClose, onUpdated }) => (
  <div className="fixed inset-0 z-50 flex items-center justify-center px-5" onClick={onClose}>
    <div className="absolute inset-0 bg-ink/60" />
    <div data-testid="lead-detail-modal" className="relative bg-ivory max-w-2xl w-full max-h-[88vh] overflow-y-auto p-8" onClick={(e) => e.stopPropagation()}>
      <div className="flex items-start justify-between gap-4 mb-6">
        <div>
          <p className="font-sans-ui text-[10px] tracking-mega text-ink/40 mb-2">LEAD</p>
          <h3 className="font-display text-3xl">{lead.brand_name}</h3>
        </div>
        <StatusBadge status={lead.status} />
      </div>

      <LeadEditor key={lead.id} lead={lead} token={token} onUpdated={onUpdated} />

      <dl className="space-y-3 font-sans-ui text-sm">
        {Object.entries(fields(lead)).map(([k, v]) => (
          <div key={k} className="flex gap-4 border-b hairline pb-2">
            <dt className="w-32 shrink-0 text-ink/45">{k}</dt>
            <dd className="text-ink/80 break-all">{v || "—"}</dd>
          </div>
        ))}
      </dl>
      <button onClick={onClose} data-testid="lead-detail-close" className="mt-6 border hairline text-ink px-6 py-3 text-[10px] tracking-mega hover:bg-linen transition-colors">CHIUDI</button>
    </div>
  </div>
);
